<template lang="pug">
  app-despachos(
    :idProcesso="idProcesso",
    :data="despachos",
    :visualizacao="true"
    :tituloMinuta="labelMinuta"
    @getDownload="getDownload"
    :tipoProcesso="tipoProcesso"
  )
</template>
<script>
import FileSaver from 'file-saver'
import axios from '@/utils/api'
import AppDespachos from '@/components/AppDespachos'
import { mapActions } from 'vuex'

export default {

  components: {
    AppDespachos
  },

  data () {
    return {
      despachos: [],
      labelMinuta: '',
      tipoProcesso: ''
    }
  },

  props: {
    idProcesso: {
      type: Number,
      required: true
    }
  },
  async created () {
    const response = await this.relatorioDespacho({idProcesso: this.idProcesso})
    this.labelMinuta = response?.despacho?.tipo === 'IMPRESSAO_ERRATA_TITULO' ? 'Minuta da errata' : response?.despacho?.processo?.tipo?.codigo === 'CERTIDAO_TITULO' ? 'Minuta da certidão' : 'Minuta do título'
    this.tipoProcesso = response?.despacho?.processo?.tipo?.codigo
    this.despachos = response.setores
  },

  methods: {
    ...mapActions({
      relatorioDespacho: 'despacho/relatorioDespachoProcesso'
    }),

    async getDownload (documento) {
      if (process.env.ESTADO === 'pa' && process.env.NODE_ENV.includes('production') && documento.caminho) {
        const base = process.env.ROOT_URL.replace('analise/', '')
        const diretorio = documento.caminho.includes('sicarf-pa') ? 'sicarf-pa' : 'sicarf'
        window.open(`${base}${diretorio}${documento.caminho.split(diretorio)[1]}`, documento?.tipo?.descricao || documento?.tipo, 'height=500,width=800,top=250px,left=250px,right=150px')

        return
      }
      const file = await axios({
        method: 'POST',
        url: `documento/file`,
        data: documento,
        responseType: 'blob'
      })
      FileSaver.saveAs(file, documento.nome)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/screens/analise/components/modal/AppVisualizarProcessoTab.vue